// extracted by mini-css-extract-plugin
module.exports = {"content":"SandBox_content__1zd9G","sideBar":"SandBox_sideBar__XWF8a"};